/** @type {['en', 'es', 'fr', 'ar', 'zh', 'ja', 'ko', 'pl', 'pt', 'ru', 'uk']} */
export const locales = ['en', 'es', 'fr', 'ar', 'zh', 'ja', 'ko', 'pl', 'pt', 'ru', 'uk']

/** @type {string[]} */
export const localeList = ['en', 'es', 'fr', 'ar', 'zh', 'ja', 'ko', 'pl', 'pt', 'ru', 'uk']
